export default {
  title: 'Resources',
  subtitle: 'Manage and browse your resources',
  createResource: 'Create Resource',
  createSubtitle: 'Add a new resource to your inventory',
  editResource: 'Edit Resource',
  editTitle: 'Edit Resource',
  editSubtitle: 'Update resource information',
  createSuccess: 'Resource created successfully',
  createError: 'Failed to create resource',
  updateSuccess: 'Resource updated successfully',
  updateError: 'Failed to update resource',
  loadError: 'Failed to load resource',
  notFound: 'Resource not found',
  images: 'Images',
  filters: {
    category: 'Category',
    availability: 'Availability',
    allCategories: 'All Categories',
    allResources: 'All Resources',
    availableOnly: 'Available Only',
    unavailableOnly: 'Unavailable Only'
  },
  loading: 'Loading resources...',
  fetchCategoriesError: 'Failed to fetch categories',
  noResources: 'No resources found',
  resourceClicked: 'Resource clicked',
  resourceForm: {
    name: 'Name',
    nameRequired: 'Name is required',
    nameMinLength: 'Name cannot be empty',
    namePlaceholder: 'Enter resource name',
    description: 'Description',
    descriptionPlaceholder: 'Enter resource description (optional)',
    category: 'Category',
    categoryRequired: 'Category is required',
    selectCategory: 'Select a category',
    location: 'Location',
    locationRequired: 'Location is required for shared resources',
    selectLocation: 'Select a location',
    resourceScope: 'Ownership',
    personal: 'Personal',
    shared: 'Shared',
    scopeTooltip: 'Personal resources belong to you and can be borrowed by everyone',
    personalResourceHelp: 'This resource will belong to you and will be visible and borrowable by all users.',
    personalOnlyHelp: 'You can only create personal resources. Contact an administrator for shared resource permissions.',
    personalLocationError: 'Personal resources cannot have a location',
    resourceType: 'Resource Type',
    consumable: 'Consumable',
    unique: 'Unique',
    consumableTooltip: 'Defines if the resource is consumable or unique',
    quantity: 'Quantity',
    availability: 'Availability',
    available: 'Available',
    unavailable: 'Unavailable',
    availabilityTooltip: 'Defines if the resource is available for use',
    notes: 'Notes',
    notesPlaceholder: 'Enter additional notes (optional)',
    saveError: 'Failed to save resource',
    fetchOptionsError: 'Failed to fetch form options'
  },
  admin: {
    createTitle: 'Create Resource',
    editTitle: 'Edit Resource',
    deleteTitle: 'Delete Resource',
    createSuccess: 'Resource created successfully',
    updateSuccess: 'Resource updated successfully',
    deleteSuccess: 'Resource deleted successfully',
    createError: 'Failed to create resource',
    updateError: 'Failed to update resource',
    deleteError: 'Failed to delete resource',
    deleteConfirmation: 'Are you sure you want to delete this resource? This action cannot be undone.'
  },

  // Resource-specific actions
  resourceRefill: {
    refillResource: 'Refill Resource',
    subtitle: 'Refill {{resourceName}}',
    loading: 'Loading...',
    notFound: 'Resource not found',
    fetchError: 'Error fetching resource',
    refillError: 'Error refilling resource'
  },

  resourceConsume: {
    consumeResource: 'Consume Resource',
    subtitle: 'Consume {{resourceName}}',
    loading: 'Loading...',
    notFound: 'Resource not found',
    fetchError: 'Error fetching resource',
    consumeError: 'Error consuming resource'
  },

  resourceBorrow: {
    borrowResource: 'Borrow Resource',
    subtitle: 'Borrow {{resourceName}}',
    loading: 'Loading...',
    notFound: 'Resource not found',
    fetchError: 'Error fetching resource',
    borrowError: 'Error borrowing resource'
  },

  resourceReserve: {
    reserveResource: 'Reserve Resource',
    subtitle: 'Reserve {{resourceName}}',
    loading: 'Loading...',
    notFound: 'Resource not found',
    fetchError: 'Error fetching resource',
    reserveError: 'Error reserving resource'
  }
};
